import dayjs, { Dayjs } from 'dayjs';
import { SimpleUser } from '../../model/types';
import { nonNullishValue } from '../helpers';

type optionalParams = { id: number; phone: string };
export const generateSerializedValue = (value: string, optionalParams?: optionalParams): string => {
    if (optionalParams) return `${optionalParams?.id ?? 'null'}:${value}:${optionalParams?.phone ?? 'null'}`;
    if (!value) return null;

    if (value.startsWith('+') && value.search(/\D/) === 0) return `null:null:${value}`;

    if (value.search(/\D/) < 0) return `null:null:${value}`;

    return `null:${value}:null`;
};

export const generateUserFriendlyValue = (fullName: string, email: string): string => {
    if (!fullName && !email) return;

    if (!fullName) return email;
    if (!email) return fullName;

    return `${fullName} (${email})`;
};

export const interpolateSerializedValueForFieldHasArrayTypeValue = (serializedValue: string): string[] =>
    serializedValue?.split(',') ?? [];

export const interpolateUserFriendlyValueForDistributionListToField = (userFriendlyValue: string): string =>
    userFriendlyValue?.replaceAll('(', '<')?.replaceAll(')', '>');

// change values from string:string to number[] for easy usage on antd component
export const interpolateSerializedValueForAssigneeField = (serializedValue: string): number[] =>
    serializedValue
        ?.split(':')
        ?.map((v) => JSON.parse(v))
        ?.filter(nonNullishValue) ?? [];

// change values as dayjs object for easy usage on antd component
export const interpolateDateTimeValue = (value: string): Dayjs => (value ? dayjs(value) : null);

export const getSerializedValueFromUser = (
    user: Pick<SimpleUser, 'email' | 'id' | 'phone'> | Pick<SimpleUser, 'email' | 'id' | 'phone'>
): string => {
    const value = user?.email;
    const optionalParams = { id: user?.id, phone: user?.phone };
    const serializedValue = generateSerializedValue(value, optionalParams);
    return serializedValue;
};

export const getUserFriendlyValueFromUser = (user: Pick<SimpleUser, 'fullName' | 'email'>): string => {
    if (!user) return;
    return generateUserFriendlyValue(user?.fullName, user?.email);
};
